import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';


const Drp_City = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const City_Onchange = (event) => {
        var index = event.nativeEvent.target.selectedIndex;
        props.onChange(event.target.value, event.nativeEvent.target[index].text)


    }
    useImperativeHandle(ref, () => ({

        BindCity(ProvinceId, cityId) {

            var MyHeader = new Headers();
            MyHeader.append("ApiKey", General.APIKey());
            MyHeader.append("ProvinceId", ProvinceId);

            var requestOption = {
                headers: MyHeader,
                method: "Get",
                credentials: 'include'
            }
            trackPromise(
                fetch(General.ApiRoute() + "/ProvinceCity/GetCityByProvinceId", requestOption)
                    .then(Response => Response.json())
                    .then(result => {
                        var lists = [];
                        for (var i = 0; i < result.length; i++) {
                            lists.push({
                                Title: result[i].title,
                                Id: result[i].id
                            })
                            if (result[i].id == cityId) {
                                props.onChange(cityId, result[i].title)
                            }
                        }
                        setList(lists)


                    })
            )


        },

    }))



    return (
        <>
            <select className={props.className} onChange={City_Onchange} value={props.value}>
                <option value="-1">انتخاب نمایید</option>
                {
                    List.map(item => (
                        <option value={item.Id}> {item.Title}  </option>
                    ))
                }

            </select>
        </>
    )
});

export default Drp_City;